import React, { useEffect, useRef } from 'react';
import { Menubar } from 'primereact/menubar';
import { useNavigate, useLocation } from 'react-router-dom';
import A_logo from '../assets/images/A_logo.png';
import { languageOptions } from '../i18n/translations';
import { useLanguage } from '../contexts/LanguageContext';

export default function BasicDemo() {
  const navigate = useNavigate();
  const location = useLocation();
  const { language, setLanguage, t } = useLanguage();
  const navbarRef = useRef<HTMLDivElement>(null);
  const horiSelectorRef = useRef<HTMLDivElement>(null);

  
  const scrollToSection = (sectionId: string, isExternalPage: boolean) => {
    if (isExternalPage) {
      if (location.pathname !== `/${sectionId}`) {
        navigate(`/${sectionId}`);
      }
    } else {
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      } else {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  };

  const items = [
    { label: t.nav.home, icon: 'pi pi-home', command: () => scrollToSection('home', false) },
    { label: t.nav.about, icon: 'pi pi-star', command: () => scrollToSection('sobre', false) },
    { label: t.nav.projects, icon: 'pi pi-search', command: () => scrollToSection('projetos', false) },
    { label: t.nav.education, icon: 'pi pi-bolt', command: () => scrollToSection('educação', false) },
    { label: t.nav.resume, icon: 'pi pi-envelope', command: () => scrollToSection('resumo-profissional', false) },
    { label: t.nav.contact, icon: 'pi pi-envelope', command: () => scrollToSection('contato', false) },
    // { label: t.nav.blog, icon: 'pi pi-envelope', command: () => navigate('/blog') },
  ];

  useEffect(() => {
    adjustSelector();
  }, []);

  function adjustSelector() {
    const tabsNewAnim = navbarRef.current;
    const activeItemNewAnim = tabsNewAnim?.querySelector('.active');
    const activeWidthNewAnimHeight = (activeItemNewAnim as HTMLDivElement)?.offsetHeight;
    const activeWidthNewAnimWidth = (activeItemNewAnim as HTMLDivElement)?.offsetWidth;
    const itemPosNewAnimTop = (activeItemNewAnim as HTMLDivElement)?.offsetTop;
    const itemPosNewAnimLeft = (activeItemNewAnim as HTMLDivElement)?.offsetLeft;

    const horiSelector = horiSelectorRef.current;
    if (horiSelector) {
      horiSelector.style.top = `${itemPosNewAnimTop}px`;
      horiSelector.style.left = `${itemPosNewAnimLeft}px`;
      horiSelector.style.height = `${activeWidthNewAnimHeight}px`;
      horiSelector.style.width = `${activeWidthNewAnimWidth}px`;
    }

    tabsNewAnim?.addEventListener('click', (e: MouseEvent) => {
      const target = e.target as HTMLDivElement;
      if (target.tagName === 'LI') {
        const activeItem = target.querySelector('.active');
        if (activeItem) {
          (activeItem as HTMLDivElement).classList.remove('active');
        }
        target.classList.add('active');
        const activeWidthNewAnimHeight = target.offsetHeight;
        const activeWidthNewAnimWidth = target.offsetWidth;
        const itemPosNewAnimTop = target.offsetTop;
        const itemPosNewAnimLeft = target.offsetLeft;
        if (horiSelector) {
          horiSelector.style.top = `${itemPosNewAnimTop}px`;
          horiSelector.style.left = `${itemPosNewAnimLeft}px`;
          horiSelector.style.height = `${activeWidthNewAnimHeight}px`;
          horiSelector.style.width = `${activeWidthNewAnimWidth}px`;
        }
      }
    });
  }

  return (
    <div className="card">
      <div className="navbar" ref={navbarRef}>
        <img src={A_logo} alt="Logo" className="logo" />
        <Menubar model={items} />
        <div className="language-switcher" aria-label={t.nav.language}>
          {languageOptions.map((option) => (
            <button
              key={option.code}
              type="button"
              className={language === option.code ? 'active-language' : ''}
              onClick={() => setLanguage(option.code)}
              aria-pressed={language === option.code}
            >
              {option.label}
            </button>
          ))}
        </div>
        <div ref={horiSelectorRef} className="hori-selector"></div>
      </div>
    </div>
  );
}
